import { bridgeService } from '@/api';

const state = {
  siteHotMap: true,
  coverPercent: {
    badPercent: 0,
    goodPercent: 0,
    middlePercent: 0
  },
  bridgeDeviceList: [], // 室外网桥产品列表
  disableOperate: true,
  isInStreeView: false
};

const mutations = {
  SET_BRIDGE_LIST(state, payload) {
    state.bridgeDeviceList = payload;
  },
  SET_SITE_HOTMAP(state, payload) {
    state.siteHotMap = payload;
  },
  SET_COVER_PERCENT(state, payload) {
    state.coverPercent = payload;
  },
  SET_DISABLE_OPERATE(state, payload) {
    state.disableOperate = payload;
  },
  SET_IS_IN_STREEVIEW(state, payload) {
    state.isInStreeView = payload;
  }
};

const actions = {
  // 获取室外网桥设备列表
  async getBridgeDeviceList({ commit }) {
    const { code, data = [] } = await bridgeService.getDeviceList({});

    if (code === 0) {
      commit('SET_BRIDGE_LIST', data);
    }
  }
};

const getters = {
  siteHotMap: state => {
    return state.siteHotMap;
  },
  disableOperate: state => {
    return state.disableOperate;
  },
  coverPercent: state => {
    return state.coverPercent;
  },
  isInStreeView: state => {
    return state.isInStreeView;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
